import ImsDeviceDetection from './DevicesList';

export default ImsDeviceDetection;
